// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const AddIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 58 58">
          <path fill="inherit" d="M29 3.625c6.778 0 13.15 2.64 17.944 7.432 4.792 4.793 7.43 11.165 7.43 17.943 0 6.777-2.638 13.15-7.43 17.942C42.15 51.735 35.776 54.375 29 54.375c-6.777 0-13.15-2.64-17.942-7.433C6.265 42.15 3.625 35.777 3.625 29c0-6.778 2.64-13.15 7.432-17.943C15.85 6.264 22.222 3.625 29 3.625M29 0C12.984 0 0 12.983 0 29c0 16.016 12.984 29 29 29s29-12.984 29-29C58 12.983 45.016 0 29 0zm14.5 25.375H32.625V14.5a3.625 3.625 0 0 0-7.25 0v10.875H14.5a3.625 3.625 0 0 0 0 7.25h10.875V43.5a3.625 3.625 0 1 0 7.25 0V32.625H43.5a3.625 3.625 0 0 0 0-7.25z"/>
        </svg>
      )
    }
  </Icon>
);

export default AddIcon;
